import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { showDialog } from "@widgets/CommonDialog";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnResizeBar from "@shared/components/SnResizeBar";
import * as converter from "@shared/utils/ValueConverterUtils";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_MTL_RCV_REG_002_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
      grid1: React.createRef<SnGridRef>(),
      grid2: React.createRef<SnGridRef>(),
    });

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    const searchRef = useRef<any>(null);

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let isSame: boolean = false;
        let isSame2: boolean = false;
        const checkedRows = getGridCurrent("grid2").getCheckedRows();
        if (checkedRows.length <= 1) return true;

        const cd_cust = converter.getString(checkedRows[0].cd_cust); // 거래처
        const rt_exch = checkedRows[0].rt_exch; // 환율

        isSame = checkedRows.every(
          (item: any) => converter.getString(item.cd_cust) === cd_cust
        );

        isSame2 = checkedRows.every((item: any) => item.rt_exch === rt_exch);

        if (!isSame) {
          await showDialog("alter", "거래처가 동일한 건만 선택 가능합니다.");
          return false;
        } else if (!isSame2) {
          await showDialog("alter", "환율이 일치하지 않는 건이 있습니다.");
          return false;
        } else {
          return true;
        }
      },
      getOkayData: () => {
        const checkedRowsL = getGridCurrent("grid2").getCheckedRows();
        const cd_cust = checkedRowsL[0]?.cd_cust;

        const matchedRowH = getGridCurrent("grid1")
          .getFilteredData()
          .find((row: any) => row.cd_cust === cd_cust);

        return {
          rtnData: [matchedRowH, checkedRowsL],
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MTL_RCV_REG_002_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_mtl_rcv_reg_002_pop_001_01",
          params: searchRef.current.getFormdata(),
        };
        getGridCurrent("grid1").resetUpdate();

        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
        });
      } catch (error: any) {}
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
        },
      }),
      [columns, dataSources]
    );

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{
              width: 80,
              marginTop: 1.5,
            }}
            spinner={true}
          />
        </div>
        <div>
          <div
            style={{
              height: "50vh",
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <SnResizeBar direction={"height"} id="panel1" orgSize="40%">
              <SnGrid
                ref={gridRefs.current["grid1"]}
                columnConfig={grids.grid1.columns}
                rowData={grids.grid1.dataSource}
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                }}
                filter={{
                  refs: [gridRefs.current["grid2"]],
                  columns: ["cd_cust"],
                }}
              />
            </SnResizeBar>
            <SnResizeBar direction={"height"} id="panel2" orgSize="60%">
              <SnGrid
                ref={gridRefs.current["grid2"]}
                columnConfig={grids.grid2.columns}
                rowData={grids.grid2.dataSource}
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                  ischeckboxSelection: true,
                }}
              />
            </SnResizeBar>
          </div>
        </div>
      </div>
    );
  }
);

export default SN_MTL_RCV_REG_002_POP_001;
